export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-02-05 at 8.30.28 PM (3) - 5272_SHREYA AGARWAL.2c3e40a4.jpeg";